export default [
  {
    path: 'investment',
    name: 'investment',
    component: () => import('./views/InvestmentView.vue'),
    meta: { 
      requiresAuth: true,
      title: 'Inversión' 
    },
  }
]